import React, { useState } from 'react';
import { Form, Button, Spinner } from 'react-bootstrap';
import { ArrowRight, CircleAlert, Eye, EyeOff, KeyRound, Mail } from 'lucide-react';
import LoginButton from '../LoginButton';
import AlertModal from '../AlertModal';
import { useHistory } from 'react-router';

export const PasswordIcon = ({ showPassword, onClick }) => {
  const Icon = showPassword ? EyeOff : Eye;
  return (
    <Icon
      size={16}
      className="text-muted cursor-pointer"
      style={{ position: 'absolute', top: '50%', right: '10px', transform: 'translateY(-50%)' }}
      onClick={onClick}
    />
  );
};

const LoginForm = ({
  onSubmit,
  formSubmitting,
  error,
  googleAuthError = null,
  setGoogleAuthError,
  onForgotPasswordClick
}) => {
  const history = useHistory();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    if (!email || !password) {
      return;
    }
    onSubmit({ email, password });
  };

  return (
    <>
      <Form id="login-form" onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <div className="position-relative">
            <Form.Control
              type="email"
              className="bg-transparent"
              placeholder="Your email"
              style={{ paddingLeft: '35px', height: '44px' }}
              value={email}
              onChange={e => setEmail(e.target.value)}
              autoFocus
              required
            />
            <Mail
              size={20}
              className="text-muted"
              style={{ position: 'absolute', top: '50%', left: '10px', transform: 'translateY(-50%)' }}
            />
          </div>
        </Form.Group>

        <Form.Group className="mb-3">
          <div className="position-relative">
            <Form.Control
              className="bg-transparent"
              placeholder="Enter your password"
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              style={{ padding: '0 35px', height: '44px' }}
            />
            <KeyRound
              size={20}
              className="text-muted"
              style={{ position: 'absolute', top: '50%', left: '10px', transform: 'translateY(-50%)' }}
            />
            <PasswordIcon showPassword={showPassword} onClick={() => setShowPassword(!showPassword)} />
          </div>
        </Form.Group>
        <p
          style={{ fontSize: 12, cursor: 'pointer', textDecoration: 'underline' }}
          className={`text-right mt-2 ${formSubmitting ? 'text-muted' : ''}`}
          onClick={() => {
            if (formSubmitting) return;
            onForgotPasswordClick?.();
          }}
        >
          Forgot password?
        </p>

        <Button
          type="submit"
          disabled={formSubmitting}
          className="btn btn-primary font-weight-bold mt-2 w-100"
          style={{ backgroundColor: '#facc15' }}
        >
          <div className="d-flex align-items-center justify-content-center">
            Sign In{' '}
            {formSubmitting ? (
              <Spinner size="sm" animation="border" className="ml-1" />
            ) : (
              <ArrowRight size={16} className="ml-1" />
            )}
          </div>
        </Button>

        <div className="text-center mt-3">
          <span className="text-muted small">OR</span>
        </div>
        <div className="mt-3">
          <LoginButton className="w-100 mb-2" />
        </div>

        {error && (
          <div className="alert alert-danger mt-2 midFont d-flex align-items-center">
            <CircleAlert size={16} className="mr-1" />
            {error}
          </div>
        )}

        <hr className="my-2" />

        <p
          style={{ fontSize: 12, cursor: 'pointer', textDecoration: 'underline' }}
          className={`text-center mx-2 ${formSubmitting ? 'text-muted' : ''}`}
          onClick={() => {
            if (formSubmitting) return;
            history.push('/signup');
          }}
        >
          Don't have an account? Click here to register
        </p>
      </Form>

      <AlertModal
        show={googleAuthError !== null}
        onHide={() => setGoogleAuthError(null)}
        onContinueClick={() => {
          setGoogleAuthError(null);
          history.push('/signup');
        }}
        continueButtonText="Sign up"
        dismissButtonText="Close"
        onDismissClick={() => setGoogleAuthError(null)}
        alertText={googleAuthError}
        progressText={''}
        showProgress={false}
      />
    </>
  );
};

export default LoginForm;
